import { CSSObject } from '@chakra-ui/react';
import errorBg from '@/assets/epicodds/images/onboarding/bg.png';
import { CustomButtonProps } from '@/components/Button/Button';

export const FlexPageWrapper = (): CSSObject => ({
  flexDirection: 'column',
  h: undefined,
  justifyContent: 'center',
  minH: '100dvh',
  bg: `url(${errorBg}) var(--bc-colors-alpha-900) center/cover no-repeat`,
  fontFamily: 'accent',
});

export const MaintenanceContainer = (): CSSObject => ({
  alignItems: 'center',
  color: 'white',
  contain: 'paint',
  gap: '0',
  h: undefined,
  justifyContent: 'center',
  maxW: 'container.md',
  mb: [null, null, '12'],
  minH: [null, null, '668px'],
  mt: ['0', null, '12'],
  mx: 'auto',
  pos: 'relative',
  px: ['4', null, '28'],
  py: ['3', null, '8'],
  textShadow: '0 4px 10px rgba(0, 0, 0, .2)',
  w: 'full',
  zIndex: '1',

  _before: {
    content: '""',
    h: '275px',
    left: '0',
    pos: 'absolute',
    top: '0',
    w: 'full',
    zIndex: '-1',
  },
});

export const ContentHeadingText: CSSObject = {
  color: 'beta.300',
  w: ['278px', '468px'],
  fontSize: ['sm', null, '2xl'],
  lineHeight: 'none',
  fontWeight: 'extrabold',
  my: '4',
  textShadow: '0px 0px 8px rgba(255, 110, 32, 0.5)',
  textTransform: 'uppercase',
  '&[data-ismaintenance="true"]': {
    w: ['278px', '500px'],
  },
};

export const ContentBodyText: CSSObject = {
  span: {
    display: 'block',
    fontSize: ['sm', null, 'md'],
    fontWeight: 'semibold',
    mb: '4',
  },
  fontFamily: 'body',
  fontWeight: 'normal',
  fontSize: ['xs', null, 'sm'],
  mb: '4',
};

export const buttonRefreshProps: CustomButtonProps = {
  variant: 'solid',
  fontWeight: 'black',
  textTransform: 'uppercase',
  fontSize: 'xs',
  h: '10',
  minW: '102px',
};

export const TextBoldDescription: CSSObject = {
  fontSize: 'md',
  color: 'white',
};
